import * as accountData from "./account-data.js";
import * as accounting from "./accounting.js";
import * as audit from "./audit.js";
import * as auth from "./auth.js";
import * as billing from "./billing.js";
import * as billingAddons from "./billing-addons.js";
import * as catalogBin from "./catalog-bin.js";
import * as catalogBooks from "./catalog-books.js";
import * as catalogLabels from "./catalog-labels.js";
import * as catalogPrices from "./catalog-prices.js";
import * as catalogProducts from "./catalog-products.js";
import * as catalogReference from "./catalog-reference.js";
import * as catalogStorefront from "./catalog-storefront.js";
import * as coupons from "./coupons.js";
import * as couriers from "./couriers.js";
import * as customers from "./customers.js";
import * as deliveryZones from "./delivery-zones.js";
import * as deployment from "./deployment.js";
import * as digital from "./digital.js";
import * as entitlements from "./entitlements.js";
import * as feedback from "./feedback.js";
import * as files from "./files.js";
import * as health from "./health.js";
import * as imports from "./imports.js";
import * as inventory from "./inventory.js";
import * as leads from "./leads.js";
import * as locations from "./locations.js";
import * as notifications from "./notifications.js";
import * as orderDesk from "./order-desk.js";
import * as orderWorkflow from "./order-workflow.js";
import * as orders from "./orders.js";
import * as payments from "./payments.js";
import * as planCatalogue from "./plan-catalogue.js";
import * as platformAdmin from "./platform-admin.js";
import * as platformOps from "./platform-ops.js";
import * as platformSettings from "./platform-settings.js";
import * as purchases from "./purchases.js";
import * as rbac from "./rbac.js";
import * as reports from "./reports.js";
import * as returns from "./returns.js";
import * as sandbox from "./sandbox.js";
import * as search from "./search.js";
import * as settings from "./settings.js";
import * as shopperAccountsAdmin from "./shopper-accounts-admin.js";
import * as signup from "./signup.js";
import * as staff from "./staff.js";
import * as stockCounts from "./stock-counts.js";
import * as storefront from "./storefront.js";
import * as storefrontAccount from "./storefront-account.js";
import * as storefrontAccountDashboard from "./storefront-account-dashboard.js";
import * as storefrontCheckout from "./storefront-checkout.js";
import * as storefrontPages from "./storefront-pages.js";
import * as storefrontPayments from "./storefront-payments.js";
import * as storefrontPlatform from "./storefront-platform.js";
import * as storefrontReviews from "./storefront-reviews.js";
import * as storefrontSeo from "./storefront-seo.js";
import * as storefrontTheme from "./storefront-theme.js";
import * as storefrontThemeLibrary from "./storefront-theme-library.js";
import * as storefrontTracking from "./storefront-tracking.js";
import * as suppliers from "./suppliers.js";
import * as sync from "./sync/index.js";
import * as transfers from "./transfers.js";
const isEndpoint = (value) => typeof value === "object" && value !== null && "method" in value && "path" in value && "access" in value;
/**
 * Every endpoint of the API (docs/specs/contracts-api-client.md). The API refuses to start if a route is missing
 * here or an endpoint here has no route.
 */
export const ENDPOINTS = [
    health,
    auth,
    rbac,
    audit,
    files,
    notifications,
    settings,
    signup,
    staff,
    entitlements,
    billing,
    billingAddons,
    platformAdmin,
    planCatalogue,
    platformOps,
    platformSettings,
    accountData,
    deployment,
    sandbox,
    leads,
    feedback,
    locations,
    catalogReference,
    catalogProducts,
    catalogBin,
    catalogPrices,
    catalogLabels,
    catalogBooks,
    digital,
    catalogStorefront,
    search,
    imports,
    inventory,
    transfers,
    stockCounts,
    suppliers,
    purchases,
    customers,
    orders,
    orderWorkflow,
    orderDesk,
    returns,
    payments,
    accounting,
    reports,
    deliveryZones,
    couriers,
    coupons,
    storefront,
    storefrontAccount,
    storefrontAccountDashboard,
    shopperAccountsAdmin,
    storefrontCheckout,
    storefrontPages,
    storefrontPlatform,
    storefrontSeo,
    storefrontTracking,
    storefrontThemeLibrary,
    storefrontPayments,
    storefrontReviews,
    storefrontTheme,
    sync,
].flatMap((module) => Object.values(module).filter(isEndpoint));
//# sourceMappingURL=endpoints.js.map